<template>
	<div class="home">
		<div class="container">
			<div class="row">
				<div class="col-12 p-md-0 text-gray mt-3 mt-md-0">
					<ml-menu></ml-menu>

					<div class="col-12 p-0 pb-3">
						<div class="container p-0 p-md-2">
							<div class="row">
								<div class="col-6 col-md-6 mt-5 mt-md-5">
									<div class="col-md-12 d-md-flex pl-0 mt-2">
										<h4>Dashboard</h4>
									</div>
								</div>
								<div class="col-6 pr-0 col-md-6 mt-5 mt-md-5 d-none d-sm-block">
									<nav aria-label="breadcrumb">
										<ol class="breadcrumb float-right">
											<li class="breadcrumb-item active"><a href="javascript:;">Dashboard</a></li>
										</ol>
									</nav>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-lg-4 col-md-12">
									<div class="col-12 col-md-6 col-lg-12 p-0 background-mila text-white rounded cus-box-shadow">
										<div class="col-12 p-0 d-flex pt-3 pb-3 pl-4">
											<div class="col-12 p-0 pt-2 pb-2">
												<div class="row">
													<div class="col-8 col-md-8 pt-3 pb-1">
														<p class="mb-n1">Kode Mobile Counter</p>
														<h3>{{profile.stockist_code}}</h3>
													</div>
													<div class="col-4 col-md-4 pt-3">
														<span><img src="assets/icon/network.png"></span>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 col-md-12 col-lg-12 mt-4 pl-0 pr-0">
										<div class="col-12 p-0 background-white rounded cus-box-shadow" v-if="Object.keys(stock).length == 0">
											<vcl :width='400' :height='222'>
												<rect x="25" y="30" rx="2" ry="2" width="100" height="25" /> 
												<rect x="70" y="80" rx="6" ry="6" width="250" height="90" /> 
												<rect x="150" y="180" rx="15" ry="15" width="15" height="15" /> 
												<rect x="180" y="180" rx="15" ry="15" width="15" height="15" /> 
												<rect x="210" y="180" rx="15" ry="15" width="15" height="15" /> 
											</vcl>
										</div>
										<div class="col-12 p-0 background-white rounded cus-box-shadow" v-if="Object.keys(stock).length > 0">
											<div class="col-12 col-md-12 pt-3 pl-4 pb-1 font-size-sm-12">
												<p class="mb-n1">Stok Produk</p>
											</div>
											<div class="col-12 pt-2 pb-3 pl-4 pr-4">
												<carousel ref="carousel" id="owl-menu" class="col-12 pl-4 pr-4 pt-2 d-flex" :responsive="{0:{items:1},600:{items:2},1000:{items:1}}" :margin="20" :autoplay="true" :nav="false" :loop="false" :dots="false">
													<template slot="prev"><span class="prev cursor-pointer"><img src="/assets/icon/button-slider-left.svg"></span></template>
													<div class="col-12 pt-2 pb-2 background-white rounded border stok-produk d-flex" v-for=" (value, index) in stock" :key="index">
														<div class="col-4 m-auto pl-0">
															<img class="img-fluid rounded" :src="value.product_image_filename">
														</div>
														<div class="col-8 m-auto pl-0 pr-0">
															<div class="col-12 pl-0 pr-0">
																<div class="font-size-10">{{ value.product_name }}</div>
															</div>
															<div class="col-12 pl-0 pr-0">
																<div :class="value.stock_store | toColorProduct" class="font-size-16 font-size-sm-13">{{ value.stock_store | toNumber }}</div>
															</div>
														</div>
													</div>
													<template slot="next"><span class="next cursor-pointer"><img src="/assets/icon/button-slider-right.svg"></span></template>
												</carousel>
											</div>
										</div>
									</div>
								</div>
								<div class="col-12 col-lg-8 col-md-12 mt-4 mt-md-4 mt-lg-0">
									<div class="col-12 p-0 background-mila text-white rounded cus-box-shadow">
										<div class="col-12 p-0 d-flex pt-3 pb-3 pl-4">
											<div class="col-12 p-0 pt-2 pb-2">
												<div class="row">
													<div class="col-12 pt-2 text-center">
														<div class="font-size-18 font-size-sm-14 mb-1">Informasi</div>
														<div class="font-size-12 font-size-sm-10 mb-2">Saat ini belum ada informasi yang bisa diinfokan</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 p-0 mt-4 background-white rounded cus-box-shadow" v-if="Object.keys(statusInput).length ==0">
										<vcl :width='400' :height='110'>
											<rect x="20" y="12" rx="2" ry="2" width="90" height="12" /> 
											<rect x="20" y="36" rx="4" ry="4" width="110" height="45" /> 
											<rect x="145" y="36" rx="4" ry="4" width="110" height="45" /> 
											<rect x="270" y="36" rx="4" ry="4" width="110" height="45" />
											<rect x="185" y="90" rx="15" ry="15" width="8" height="8" />
											<rect x="200" y="90" rx="15" ry="15" width="8" height="8" />
										</vcl>
									</div>
									<div class="col-12 p-0 mt-4 background-white rounded cus-box-shadow" v-if="Object.keys(statusInput).length > 0">
										<div class="col-12 p-0 d-flex pt-3 pl-4">
											<div class="col-12 p-0">
												<div class="row">
													<div class="col-12 col-md-12 font-size-sm-12">
														<p class="mb-n1">Data Status Transaksi</p>
													</div>
												</div>
												<div class="row pr-md-4 pr-3 pt-3 pb-2">
													<div class="col-12 col-md-12 pl-0 pb-2">
														<carousel ref="carousel" id="owl-menu" class="col-12 pl-0 pr-0" :responsive="{0:{items:1},768:{items:3},1000:{items:3}}" :autoplay="true" :nav="false" :loop="false" :dots="false">
															<template slot="prev"><span class="prev cursor-pointer"><img src="/assets/icon/button-slider-left.svg"></span></template>
															<div class="col-12 pt-2 pb-2" v-for="(value, index) in statusInput" :key="index">
																<div class="col-lg-12 pt-2 pb-2 font-size-11 background-white rounded cus-box-shadow status-trans">
																	<div class="col-12 pl-0 pr-0 text-center">
																		<div class="font-size-10">{{ value[0] | toStatus }}</div>
																	</div>
																	<div class="col-12 d-flex pt-2">
																		<div class="col-6 pl-4 pr-3 mt-auto mb-auto" v-if="value[0] == 3">
																			<img class="img-fluid width-80-pct width-sm-30-pct float-right" src="/assets/icon/pembayaran-sukses.svg">
																		</div>
																		<div class="col-6 pl-4 pr-3 mt-auto mb-auto" v-if="value[0] == 4">
																			<img class="img-fluid width-80-pct width-sm-30-pct float-right" src="/assets/icon/sedang-diproses.svg">
																		</div>
																		<div class="col-6 pl-4 pr-3 mt-auto mb-auto" v-if="value[0] == 6">
																			<img class="img-fluid width-sm-30-pct float-right" src="/assets/icon/sudah-dikirim.svg">
																		</div>
																		<div class="col-6 pl-4 pr-3 mt-auto mb-auto" v-if="value[0] == 7">
																			<img class="img-fluid width-sm-30-pct float-right" src="/assets/icon/sudah-diambil.svg">
																		</div>
																		<div class="col-6 pl-4 pr-3 mt-auto mb-auto" v-if="value[0] == 9">
																			<img class="img-fluid width-80-pct width-sm-30-pct float-right" src="/assets/icon/selesai.svg">
																		</div>
																		<div class="col-6 m-auto pl-0 pr-0">
																			<div class="font-size-18">{{ value[1] | toNumber }}</div>
																		</div>
																	</div>
																</div>
															</div>
															<template slot="next"><span class="next cursor-pointer"><img src="/assets/icon/button-slider-right.svg"></span></template>
														</carousel>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-lg-6 col-md-12 mt-4">
									<div class="col-12 p-0 background-white rounded cus-box-shadow" v-if="Object.keys(stokPengambilan).length == 0">
										<vcl :width='400' :height='180'>
											<rect x="20" y="20" rx="2" ry="2" width="100" height="12" /> 
											<rect x="20" y="50" rx="2" ry="2" width="85" height="12" /> 
											<rect x="20" y="70" rx="2" ry="2" width="60" height="12" /> 
											<rect x="20" y="90" rx="2" ry="2" width="65" height="12" /> 
											<rect x="20" y="110" rx="2" ry="2" width="80" height="12" /> 
											<rect x="20" y="130" rx="2" ry="2" width="80" height="12" /> 
											<rect x="120" y="50" rx="2" ry="2" width="87" height="12" /> 
											<rect x="120" y="70" rx="2" ry="2" width="60" height="12" /> 
											<rect x="120" y="90" rx="2" ry="2" width="60" height="12" /> 
											<rect x="120" y="110" rx="2" ry="2" width="60" height="12" /> 
											<rect x="120" y="130" rx="2" ry="2" width="60" height="12" /> 
											<rect x="220" y="50" rx="2" ry="2" width="85" height="12" />
											<rect x="220" y="70" rx="2" ry="2" width="70" height="12" />
											<rect x="220" y="90" rx="2" ry="2" width="75" height="12" />
											<rect x="220" y="110" rx="2" ry="2" width="70" height="12" />
											<rect x="220" y="130" rx="2" ry="2" width="70" height="12" />
											<rect x="312" y="50" rx="2" ry="2" width="50" height="12" />
											<rect x="312" y="70" rx="2" ry="2" width="70" height="12" />
											<rect x="312" y="90" rx="2" ry="2" width="72" height="12" />
											<rect x="312" y="110" rx="2" ry="2" width="73" height="12" />
											<rect x="312" y="130" rx="2" ry="2" width="70" height="12" />
										</vcl>
									</div>
									<div class="col-12 p-0 background-white rounded cus-box-shadow" v-else>
										<div class="col-12 p-0 d-flex pt-3 pl-4 pb-1">
											<div class="col-12 p-0">
												<div class="row">
													<div class="col-12 col-md-12 font-size-sm-12">
														<p class="mb-n1">Data Pengambilan</p>
													</div>
												</div>
												<div class="row pr-md-4 pr-3 pl-2 pt-4">
													<div class="col-12 col-md-12 pl-md-0 pl-0 overflow-auto table-height">
														<table class="table table-sm table-borderless width-130-pct width-sm-210-pct">
															<thead class="font-weight-normal font-size-10">
																<tr>
																	<th scope="col" class="font-weight-normal">Tanggal Transaksi</th>
																	<th scope="col" class="font-weight-normal">Kode Transaksi</th>
																	<th scope="col" class="font-weight-normal">Nama Pembeli</th>
																	<th scope="col" class="font-weight-normal">No HP</th>
																	<th scope="col" class="font-weight-normal">Status</th>
																</tr>
															</thead>
															<tbody v-if="stokPengambilan == 'error'">
																<div class="col-md-12 col-12 text-center data-kosong">
																	<img src="assets/icon/stock_empty.svg" width="100px;">
																	<p class="mb-n1 font-size-sm-11 font-size-12">Data Tidak Tersedia</p>
																</div>
															</tbody>
															<tbody v-else>
																<tr v-for="(value, index) in stokPengambilan" :key="index">
																	<td class="font-size-10">{{ value.trx_datetime | toTanggal}}</td>
																	<td class="font-size-10">{{value.trx_code}}</td>
																	<td class="font-size-10">{{ value.trx_buyer_name}}</td>
																	<td class="font-size-10">{{value.trx_buyer_mobilephone}}</td>
																	<td class="font-size-10">{{value.trx_status | toStatus}}</td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-12 col-lg-6 col-md-12 mt-4">
									<div class="col-12 p-0 background-white rounded cus-box-shadow" v-if="Object.keys(stokPengiriman).length == 0">
										<vcl :width='400' :height='180'>
											<rect x="20" y="20" rx="2" ry="2" width="100" height="12" /> 
											<rect x="20" y="50" rx="2" ry="2" width="85" height="12" /> 
											<rect x="20" y="70" rx="2" ry="2" width="60" height="12" /> 
											<rect x="20" y="90" rx="2" ry="2" width="65" height="12" /> 
											<rect x="20" y="110" rx="2" ry="2" width="80" height="12" /> 
											<rect x="20" y="130" rx="2" ry="2" width="80" height="12" /> 
											<rect x="20" y="150" rx="2" ry="2" width="80" height="12" /> 
											<rect x="120" y="50" rx="2" ry="2" width="87" height="12" /> 
											<rect x="120" y="70" rx="2" ry="2" width="60" height="12" /> 
											<rect x="120" y="90" rx="2" ry="2" width="60" height="12" /> 
											<rect x="120" y="110" rx="2" ry="2" width="60" height="12" /> 
											<rect x="120" y="130" rx="2" ry="2" width="60" height="12" /> 
											<rect x="120" y="150" rx="2" ry="2" width="60" height="12" /> 
											<rect x="220" y="50" rx="2" ry="2" width="85" height="12" />
											<rect x="220" y="70" rx="2" ry="2" width="70" height="12" />
											<rect x="220" y="90" rx="2" ry="2" width="75" height="12" />
											<rect x="220" y="110" rx="2" ry="2" width="70" height="12" />
											<rect x="220" y="130" rx="2" ry="2" width="70" height="12" />
											<rect x="220" y="150" rx="2" ry="2" width="70" height="12" />
											<rect x="312" y="50" rx="2" ry="2" width="50" height="12" />
											<rect x="312" y="70" rx="2" ry="2" width="70" height="12" />
											<rect x="312" y="90" rx="2" ry="2" width="72" height="12" />
											<rect x="312" y="110" rx="2" ry="2" width="73" height="12" />
											<rect x="312" y="130" rx="2" ry="2" width="70" height="12" />
											<rect x="312" y="150" rx="2" ry="2" width="70" height="12" />
										</vcl>
									</div>
									<div class="col-12 p-0 background-white rounded cus-box-shadow" v-else>
										<div class="col-12 p-0 d-flex pt-3 pl-4 pb-1">
											<div class="col-12 p-0">
												<div class="row">
													<div class="col-12 col-md-12 font-size-sm-12">
														<p class="mb-n1">Data Pengiriman</p>
													</div>
												</div>
												<div class="row pr-md-4 pr-3 pl-2 pt-4">
													<div class="col-12 col-md-12 pl-md-0 pl-0 overflow-auto table-height">
														<table class="table table-sm table-borderless width-130-pct width-sm-210-pct">
															<thead class="font-weight-normal font-size-10">
																<tr>
																	<th scope="col" class="font-weight-normal">Tanggal Transaksi</th>
																	<th scope="col" class="font-weight-normal">Kode Transaksi</th>
																	<th scope="col" class="font-weight-normal">Nama Pembeli</th>
																	<th scope="col" class="font-weight-normal">No HP</th>
																	<th scope="col" class="font-weight-normal">Status</th>
																</tr>
															</thead>
															<tbody  v-if="stokPengiriman == 'error'">
																<div class="col-md-12 col-12 text-center data-kosong">
																	<img src="assets/icon/stock_empty.svg" width="100px;">
																	<p class="mb-n1 font-size-sm-11 font-size-12">Data Tidak Tersedia</p>
																</div>
															</tbody>
															<tbody v-else>
																<tr v-for="(value, index) in stokPengiriman" :key="index">
																	<td class="font-size-10">{{ value.trx_datetime | toTanggal}}</td>
																	<td class="font-size-10">{{value.trx_code}}</td>
																	<td class="font-size-10">{{ value.trx_buyer_name}}</td>
																	<td class="font-size-10">{{value.trx_buyer_mobilephone}}</td>
																	<td class="font-size-10">{{value.trx_status | toStatus}}</td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-lg-8 col-md-12 mt-4" v-if="chartData">
									<div class="col-12 p-0 background-white rounded cus-box-shadow">
										<div class="col-12 p-0 d-flex pt-3 pl-4">
											<div class="col-12 p-0">
												<div class="row">
													<div class="col-12 col-md-12 font-size-sm-11">
														<p class="mb-n1">Data Penjualan Tahun {{salesSummary.year }}</p>
													</div>
												</div>
												<div class="row pr-3">
													<div class="col-12 col-md-12 pl-md-0 table-responsive pb-3">
														<GChart
														type="LineChart"
														:data="chartData"
														:options="chartOptions"
														:resizeDebounce="500"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-12 col-lg-4 col-md-6 mt-4" v-if="buyerChartData">
									<div class="col-12 p-0 background-white rounded cus-box-shadow">
										<div class="col-12 p-0 d-flex pt-3 pl-4">
											<div class="col-12 p-0">
												<div class="row">
													<div class="col-lg-12 font-size-sm-11">
														<p>Data Penjualan Produk</p>
													</div>
												</div>
												<div class="row pr-3">
													<div class="col-12 col-md-12 pl-md-0 table-responsive pb-2">
														<GChart
														type="PieChart"
														:data="buyerChartData"
														:options="pieChartOptions"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<VModal ref="modalAlamat" type="modal-xl">
			<template v-slot:title>
				<div class="text-center">
					Tambahkan Alamat Anda
				</div>
			</template>
			<template v-slot:body class="font-size-11">
				<div class="container-fluid font-size-11 font-size-sm-10 pb-3">
					<div class="col-12 background-blue-light text-blue rounded pt-2 pb-2 d-flex">
						<div class="font-size-12 m-auto"><i class="fas fa-exclamation-circle"></i></div>
						<div class="font-size-10 pl-2"> Silakan melengkapi  detail Alamat utama Mobile Counter Anda untuk data Pengiriman dan Verifikasi akun menjadi lebih lengkap. Pastikan Anda melengkapi data dengan benar.</div>
					</div>
					<form>
						<div class="row">
							<div class="col-md-6">
								<div class="row">
									<div class="col-md-12 pt-3">
										<div class="mb-1">Provinsi</div>
										<select class="form-control font-size-10 box-purple" v-model="provinsi" @change="selectProv(provinsi)">
											<option value="">Pilih Provinsi</option>
											<option v-for="(value, index) in province" :key="index" :value="{ id: value.province_id, text: value.province }">Provinsi {{value.province}}</option>
										</select>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12">
										<div class="mb-1 mt-3">Kota/Kabupaten</div>
										<select class="form-control font-size-10 box-purple" v-model="kota" @change="selectCity(kota)">
											<option value="">Pilih Kota/Kabupaten</option>
											<option v-for="(value, index) in city" :key="index" :value="{id: value.city_id, text: value.city_name}">{{value.type}} {{value.city_name}}</option>
										</select>
										<div class="invalid-feedback d-block m-0" v-if="errors.city_id"> {{ errors.city_name }} </div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12">
										<div class="mb-1 mt-3">Kecamatan</div>
										<select class="form-control font-size-10 box-purple" v-model="kecamatan" @change="selectDistrict(); updateMaps()">
											<option value="">Pilih Kecamatan</option>
											<option v-for="(value, index) in subdistrict" :key="index" :value="{id: value.subdistrict_id, text: value.subdistrict_name}">Kecamatan {{value.subdistrict_name}}</option>
										</select>
										<div class="invalid-feedback d-block m-0" v-if="errors.subdistrict_id"> {{ errors.subdistrict_id }} </div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12">
										<div class="mb-1 mt-3">Alamat Lengkap</div>
										<textarea class="form-control font-size-10 textarea box-purple" rows="3" placeholder="Masukkan Alamat Lengkap" v-model="alamat" @keyup="getAlamat()" @blur="updateMaps(alamat)"></textarea>
										<div class="invalid-feedback d-block m-0" v-if="errors.address"> {{ errors.address }} </div>
									</div>
								</div>
							</div>
							<div class="col-md-6 mt-4">
								<GmapMap
								:center="{
								lat: location.lat,
								lng: location.lng
							}"
							:zoom="16"
							:options="{
							zoomControl: false,
							mapTypeControl: false,
							scaleControl: false,
							streetViewControl: false,
							rotateControl: false,
							fullscreenControl: false,
							disableDefaultUi: true
						}"
						map-type-id="roadmap"
						style="width: 100%; height: 100%"
						>
						<GmapMarker
						ref="myMarker"
						:position="{
						lat: location.lat,
						lng: location.lng
					}"
					:draggable="true"
					@dragend="updateCoordinates"
					/>
				</GmapMap>
			</div>
		</div>
	</form>
</div>
</template>
<template v-slot:footer>
	<div class="row">
		<div class="col-10 offset-1 col-md-4 offset-md-4 text-center pt-md-3 pb-3">
			<button @click="berhasil()" class="btn btn-mila btn-block text-white font-size-10 box-purple"><img src="assets/icon/simpan.png" class="pr-2 img-fluid mt-n1">SIMPAN</button>
		</div>
	</div>
</template>
</VModal>

<VModal ref="modalBerhasil">
	<template v-slot:title>
		<div>Berhasil</div>
	</template>
	<template v-slot:body class="font-size-11">
		<div class="container-fluid font-size-11 font-size-sm-10 pb-3 d-flex pl-0 pr-0">
			<div class="col-5 pl-0 pr-0"><img src="assets/loading/smile-woman.svg" alt=""></div>
			<div class="col-7 pl-0 pr-0">
				<div class="col-12 pl-0 pr-0 pt-3">Terimakasih sudah memperbaharui data alamat Anda</div>
				<div class="pt-4">
					<button class="btn col-11 btn-mila text-white"  @click="$refs.modalBerhasil.modalHide();"><span class="font-size-11">OK</span></button>
				</div>
			</div>
		</div>
	</template>
	<template v-slot:footer>
		<div></div>
	</template>
</VModal>
</div>
</template>

<script>
import { GChart } from 'vue-google-charts'
import { mapState, mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import VModal from '@/components/VModal'
import carousel from 'vue-owl-carousel';

export default {
	components: {
		GChart,
		VModal,
		carousel,
	},
	data() {
		return {
			transaction_payment_method:'Transfer',
			provinsi:'',
			kota:'',
			kecamatan:'',
			alamat:'',
			chartOptions: {
				chart: {
					title: 'Sales Data'
				},
				chartArea:{top:50,left:55,right:0},
				width: 690,
				height: 365,
				fontName: 'Poppins',
				fontSize: 12,
				legend: 'bottom',
				colors: ['#3b2eb2', '#cd78db', 'grey']
			},
			pieChartOptions: {
				chart: {
					title: 'Stock Data'
				},
				tooltip: {
					ignoreBounds: true,
					text: 'value',
				},
				chartArea:{top:60, left:55},
				width: 345,
				height: 350,
				fontSize: 13,
				legend: 'none',
				pieSliceText: 'label',
				fontName: 'Poppins',
				pieHole: 0.4,
				colors: ['#3b2eb2', '#cd78db', 'grey']
			},
			update: {
				address: '',
				province_id: '',
				province_name: '',
				city_id: '',
				city_name: '',
				subdistrict_id: '',
				subdistrict_name: '',
			},
		}
	},
	computed: {
		...mapState('dashboardList', ['status', 'stock',  'stockAktivasi', 'stockRo', 'stockTransaction', 'profile', 'salesSummary', 'totalSales', 'stokPengambilan', 'stokPengiriman']),
		...mapState('profileList', ['province', 'city', 'subdistrict', 'errors']),
		...mapState('maps', ['location']),

		...mapGetters('auth', ['isAuth', 'profile']),
		...mapGetters('dashboardList', ['chartData', 'serialChartData', 'buyerChartData', 'statusInput']),
	},

	methods: {
		...mapActions('dashboardList', ['getStock', 'getDataSerial', 'getTransaction', 'getProfile', 'getSalesSummary', 'getTotalSales', 'dataPickup', 'dataShipping', 'getStatus', 'getProvince', 'getCity', 'getSubdistrict',]),
		...mapActions('profileList', ['getProvince', 'getCity', 'getSubdistrict', 'submit']),
		...mapActions('maps', ['postGeolocation', 'getMaps', 'getGeolocation']),

		cekExpiredDates(status, date) {
			let datetime = moment().format('YYYY-MM-DD');

			if (status == 1) {
				return `<span  class="pt-1 pb-2 pl-2 background-purple float-right text-white font-size-9 rounded-bot-left-pill stok-badge text-center"> TERJUAL </span>`
			} else if(moment(date).isBefore(datetime)) {
				return `<span  class="pt-1 pb-2 pl-2 background-gray-dark float-right text-white font-size-9 rounded-bot-left-pill stok-badge text-center"> KADALUARSA </span>`
			} else {
				return 	`<span  class="pt-1 pb-2 pl-2 background-green float-right text-white font-size-9 rounded-bot-left-pill stok-badge text-center"> TERSEDIA</span>`
			}
		},
		cekAlamat() {
			if(!this.profile.stockist_origin_province_id || !this.profile.stockist_origin_city_id || !this.profile.stockist_origin_subdistrict_id || !this.profile.stockist_origin_address)
			{
				this.getGeolocation();
				this.getProvince();
				this.$refs.modalAlamat.modalShow();
			}
		},
		selectProv(val) {
			this.kota = '',
			this.kecamatan = '',
			this.getCity(val.id)
			this.errors.province_id = ''
		},
		selectCity(val) {
			this.getSubdistrict(val.id)
			this.errors.city_id = ''
		},
		selectDistrict() {
			this.errors.subdistrict_id = ''
		},
		berhasil() {
			this.update.province_id = this.provinsi.id
			this.update.province_name = this.provinsi.text
			this.update.city_id = this.kota.id
			this.update.city_name = this.kota.text
			this.update.subdistrict_id = this.kecamatan.id
			this.update.subdistrict_name = this.kecamatan.text
			this.update.address = this.alamat
			this.update.lat = this.location.lat
			this.update.lng = this.location.lng
			this.submit(this.update)

			if(this.provinsi && this.kota && this.kecamatan && this.alamat) {
				this.$refs.modalAlamat.modalHide()
				this.$refs.modalBerhasil.modalShow();
				this.provinsi = ''
				this.kota = ''
				this.kecamatan = ''
				this.alamat = ''
			} else {
				this.$refs.modalAlamat.modalShow()
			}
		},
		updateCoordinates(location) {
			this.postGeolocation({
				lat: location.latLng.lat(),
				lng: location.latLng.lng()
			})
		},
		updateMaps(address = null) {
			this.getMaps((address ? address + ', ' : '') + this.kecamatan.text + ', ' + this.kota.text + ', ' + this.provinsi.text)
		},
	},
	created() {
		this.getStock();
		this.getDataSerial();
		this.getTransaction();
		this.getProfile();
		this.getSalesSummary();
		this.getTotalSales();
		this.dataPickup();
		this.dataShipping();
		this.getStatus();
		this.$store.dispatch('setPageTitle', `Dashboard`);
	},
	mounted() {
		this.cekAlamat();
	},
	beforeDestroy() {
		this.$refs.modalAlamat.modalHide();
	}
}
</script>

<style scoped>
.next {
	position: absolute;
	top: 2rem;
	right: -1.4rem;
}
.prev {
	position: absolute;
	top: 2rem;
	left: -1.4rem;
}
.stok-produk {
	min-height: 6rem;
}
.status-trans {
	min-height: 5.4rem;
}
.width-180-pct {
	width: 180% !important;
}
.table-height {
	min-height: 12rem;
	max-height: 12rem;
	overflow-y: auto;
}
.data-kosong {
	position: absolute;
}
</style>